export interface SelectionRange {
  readonly start: number;
  readonly end: number;
}

export interface DigitPasteParams {
  readonly currentValue: string;
  readonly selection: SelectionRange;
  readonly pastedText: string;
  readonly maxLength: number;
}

export function isKeyboardNavigationOrEditKey(key: string): boolean {
  return key === 'Backspace' || key === 'Delete' || key === 'Tab' ||
    key === 'Enter' || key === 'Escape' || key === 'Home' || key === 'End' ||
    key.startsWith('Arrow');
}

export function isPrintableDigitKey(key: string): boolean {
  return /^[0-9]$/.test(key);
}

export function sanitizeDigitsOnly(value: string): string {
  return value.replace(/[^0-9]+/g, '');
}

export function canInsertDigit(currentValue: string, selection: SelectionRange, maxLength: number): boolean {
  const selectedLength = Math.max(0, selection.end - selection.start);
  const remaining = maxLength - (currentValue.length - selectedLength);
  return remaining > 0;
}

export function applyDigitPaste(params: DigitPasteParams): string {
  const digits = sanitizeDigitsOnly(params.pastedText);
  const selectedLength = Math.max(0, params.selection.end - params.selection.start);
  const capacity = Math.max(0, params.maxLength - (params.currentValue.length - selectedLength));
  const insert = digits.slice(0, capacity);

  return params.currentValue.slice(0, params.selection.start) + insert + params.currentValue.slice(params.selection.end);
}

